import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface NISProductDetailsManufacturingPartNumberStyles {
    labelText?: TypographyProps;
    labelValue?: TypographyProps;
    valueText?: TypographyProps;
}

export const nisManufacturingPartNumberStyles: NISProductDetailsManufacturingPartNumberStyles = {
    labelText: {
        css: css`
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: 24px;
            color: #444444;
            font-family: Roboto Condensed;
            display: flex;
            ${({ theme }: { theme: BaseTheme }) => breakpointMediaQueries(theme, [null, null, null, null, null], "max")}
        `,
    },
    labelValue: {
        css: css`
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: 24px;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: ${TYPOGRAPHY.size.smaller};
                            line-height: 20px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    valueText: {
        css: css`
            margin-top: 3px;
            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 16px;
                    `,
                    css`
                        margin-bottom: 16px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = nisManufacturingPartNumberStyles;

const NISProductDetailsManufacturingPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.manufacturerItem) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="h2">
            <Typography {...styles.labelText}>
                {translate("MPN:")} {product.manufacturerItem}
            </Typography>
            {/* <Typography {...styles.labelValue}> {product.manufacturerItem}</Typography> */}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(NISProductDetailsManufacturingPartNumber),
    definition: {
        displayName: "NIS Manufacturing Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
